// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body[data-v-6ab320ce]{overflow-y:hidden}.hospitalTitle[data-v-6ab320ce]{text-align:center;margin:0;padding:6vh 0 5px;font-size:28px;color:#fff;letter-spacing:1px}.van-icon[data-v-6ab320ce]{float:right;margin-right:1.5rem}.van-tabbar-item__icon img[data-v-6ab320ce]{height:14px}.mainContainer[data-v-6ab320ce]{position:relative;top:-2rem}[data-v-6ab320ce]:export{green:#1989fa;white:#fff}", ""]);
// Exports
module.exports = exports;
